import { render, staticRenderFns } from "./ShopAvailble.vue?vue&type=template&id=36d163d3&"
import script from "./ShopAvailble.vue?vue&type=script&lang=js&"
export * from "./ShopAvailble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports